import { apiServiceV2 } from ".";

export const login = async (userId: string, password: string, userType: number) => {
	const response = await apiServiceV2.post("/auth/login", {
		userId,
		password,
		userType,
	});
	window.localStorage.setItem("accessToken", response.data.accessToken);
	window.localStorage.setItem("refreshToken", response.data.refreshToken);
	return response.data;
};

export const registerWithLogin = async (userId: string, password: string, key: string) => {
	const response = await apiServiceV2.post("/auth/loginWithRegister", {
		userId,
		password,
		key,
	});
	window.localStorage.setItem("accessToken", response.data.accessToken);
	window.localStorage.setItem("refreshToken", response.data.refreshToken);
	return response.data;
};

interface CompanyUserSignUpData {
	userEmail: string;
	password: string;
	phone: string;
	name: string;
	marketing_consent: boolean;
	companyInfoUuid: string;
	position: string;
}

interface SignupData {
	userEmail: string;
	password: string;
	knownPath: string;
	phoneAuth: string;
	emailAuth: string;
	phone: string;
	name: string;
	userType: number;
	nickname?: string;
	marketing_consent: boolean;
	inviteCode?: string;
}

interface SingupWithCompanyInfoData extends SignupData {
	brandUrl: string;
	brandName: string;
	companyIndustry: string;
	companyName: string;
	companySize: string;
	companyType: string;
	roundOfInvestment: string;
	position: string;
}

export interface SignUpRequestV2 {
	userEmail: string;
	password: string;
	knownPath: string;
	phone: string;
	name: string;
	marketingConsent: boolean;
	position: string;
	companyName: string;
	companySize: string;
	industry: string;
}

export interface SubscribeStibeeRequest {
	email: string;
	ads: "O" | "X";
	type: "고객사" | "소개서" | "인사이트" | "프로필";
}

export const subscribeStibee = async (data: SubscribeStibeeRequest) => {
	const response = await apiServiceV2.post("/utils/stibee/subscribe", data);
	return response.data;
};

export const sendFindPasswordMail = async (email: string): Promise<{ id: string }> => {
	const response = await apiServiceV2.post("/auth/email/password", { email });
	return response.data;
};

export const signup = async (userData: SignupData) => {
	const response = await apiServiceV2.post("/auth/join", { ...userData });

	window.localStorage.setItem("accessToken", response.data.accessToken);
	window.localStorage.setItem("refreshToken", response.data.refreshToken);
	return response.data;
};

export const signupCompanyUser = async (userData: CompanyUserSignUpData) => {
	const response = await apiServiceV2.post("/auth/join/company-user", { ...userData });

	window.localStorage.setItem("accessToken", response.data.accessToken);
	window.localStorage.setItem("refreshToken", response.data.refreshToken);
	return response.data;
};

export const signupCompanyUserV2 = async (userData: CompanyUserSignUpData) => {
	const response = await apiServiceV2.post("/auth/join/company-user/v2", { ...userData });

	window.localStorage.setItem("accessToken", response.data.accessToken);
	window.localStorage.setItem("refreshToken", response.data.refreshToken);
	return response.data;
};

export const signupV2 = async (userData: SignUpRequestV2) => {
	const response = await apiServiceV2.post("/auth/join/v2", { ...userData });

	window.localStorage.setItem("accessToken", response.data.accessToken);
	window.localStorage.setItem("refreshToken", response.data.refreshToken);
	return response.data;
};

export const signupWithCompanyInfo = async (userData: SingupWithCompanyInfoData) => {
	const response = await apiServiceV2.post("/auth/join", { ...userData });

	window.localStorage.setItem("accessToken", response.data.accessToken);
	window.localStorage.setItem("refreshToken", response.data.refreshToken);
	return response.data;
};

export const sendCert = async (
	authData: string,
	type: "phone" | "email",
): Promise<{ id: string }> => {
	const response = await apiServiceV2.post(`/auth/${type}`, { authData });
	return response.data;
};

export const sendGetIds = async (certId: string, type: "client" | "expert"): Promise<string[]> => {
	const response = await apiServiceV2.get(`/auth/ids?certId=${certId}&type=${type}`);
	return response.data;
};

export const confirmCert = async (id: string, authNumber: string) => {
	const response = await apiServiceV2.post(`/auth/cert`, { id, authNumber });
	return response.data;
};

export const changePassword = async (id: string, authNumber: string, password: string) => {
	const response = await apiServiceV2.post(`/auth/password/change`, {
		id,
		authNumber,
		password,
	});
	return response.data;
};
